import type { PartialStoreState } from '../typings'

export const selectApplicationClock = (state: PartialStoreState) =>
  state.domain.publicData.applicationClock
